<template>
  <!-- <div id="main-container" class="" style="padding-top:40px; background-color:red"> -->
  <!-- container -->
  <div class="row q-pa-md" style="margin: 0 auto; max-width: 1280px">
    <!-- Left Side -->
    <div class="col-xs-12 col-sm-12 col-md-6" v-if="product">
      <div>
        <q-carousel width="100%" animated v-model="slide" swipeable arrows fullscreen :fullscreen.sync="fullscreen" :autoplay="autoplay" ref="carousel" infinite >
          <q-carousel-slide :name="index" v-for="(image, index) in product.images" v-bind:key="index" class="column no-wrap">
            <img :src="image.url" class="rounded-borders col-12" style="object-fit: scale-down"/>
          </q-carousel-slide>
        </q-carousel>
      </div>
      <div id="sub_images" class="row col-12">
        <div v-for="(image, index) in product.images" :style="slide == index ? selected : null" v-bind:key="index" style=" width: 90px; height: 90px; border: solid 1px silver; margin: 5px; " @click="slide = index" >
          <q-img 
            :src="image.url"
            width="100%"
            height="100%"
            spinner-color="primary"
            spinner-size="10px"
          />
        </div>
      </div>
    </div>
    <!-- Right Side -->
    <div v-if="productDetails && product" class="col-xs-12 col-sm-12 col-md-6 q-pa-sm">
      <q-badge
        v-if="productDetails.basic_details.options.show_status_tag"
        class="customBadge"
        color="blood"
        label="New"
      ></q-badge>
      <div style="font-size: 44px">{{ product.name }}</div>
      <div
        v-if="productDetails.basic_details.show_subtitle"
        id="short_description"
      >
      <span style="font-weight:bold">Limited Pre-Order, delivery Mid-May</span>
      </div>
      <div id="second_line" style="margin-top: 10px">
        <div
          id="price"
          style="font-size: 24px; color: #6f6f6f; display: inline"
        >
          ${{Number(product.skus[0].retailPrice).toFixed(2)}}
        </div>
        <div
          v-if="productDetails.basic_details.options.show_rating_stars"
          id="reviews"
          class="text-right"
          style="display: inline; float: right"
        >
          <q-icon size="sm" color="red-10" name="star" />
          <q-icon size="sm" color="red-10" name="star" />
          <q-icon size="sm" color="red-10" name="star_half" />
          <q-icon size="sm" color="red-10" name="star_outline" />
          <q-icon size="sm" color="red-10" name="star_outline" />
          <!-- <div id="review_link" style="display:inline"><a href="http://localhost">Read reviews</a></div> -->
        </div>
      </div>
      <!-- <q-separator class="q-my-lg"></q-separator> -->
      <div
        id="long_description"
        style="padding: 15px 0; text-align: justify; text-justify: inter-word"
      >
        Own a climbing gym in your own home and you can climb day or night. Create your own climbs or add one of the many training board options available in the ICP Store.<br>
        Best of all, the wall is self supporting and easy to maintain<br>
        Climb anytime on your ICP Home

        <ul>
          <li><span style="font-weight:bold">Human Rights </span>- We only buy materials from countries that respect human life. </li>
          <li><span style="font-weight:bold">Ethically Sourced </span>- We only buy timber that is sustainable. </li>
          <li><span style="font-weight:bold">Quality </span>- We only use the highest grade materials. </li>
        </ul>


        <div style="text-align:right;">Safety Matting not included with your purchase</div>
      </div>
      <q-separator class="q-my-lg"></q-separator>
      <div id="colour_selection" class="row" style="height: 40px; display:none">
        <div
          style="
            display: inline;
            font-size: 16px;
            margin-right: 20px;
            line-height: 40px;
          "
        >
          Colour:
          <span class="text-bold">{{
            product.skus[colourSelection].options.colour.group
          }}</span>
        </div>
        <!-- <div style="display:inline; width:200px">
              <q-select outlined v-model="colourSelection" :options="colourOptions" dense options-dense>
                <template v-slot:prepend>
                  <q-icon name="event" />
                </template>
              </q-select>
            </div> -->
      </div>
      <div
        class="row"
        id="colour_display"
        style="margin: 20px"
        v-if="setQtyComp"
      >
        <!-- <div style="position:absolute; background-color:red; width: 20px; height:20px;border:1px black solid; border-radius:50px">X</div>
            <div style="background-color:yellow; width: 40px; height:40px;border:1px silver solid; border-radius:50px"> -->
        <!-- </div> -->
        <div id="colour_component" style="display:none; width: 60px" v-for="(sku, index) in product.skus" @click="colourSelection = index" >
          <div id="caja" style="width: 50px; height: 50px; margin: 0 auto">
            <div
              v-if="colourSelection == index"
              id="selector"
              style="
                border-radius: 50px;
                position: absolute;
                width: 50px;
                height: 50px;
                border: 2px solid black;
              "
            ></div>
            <div
              v-if="colourSelection == index"
              id="tick"
              style="
                border: 2px solid white;
                border-radius: 50px;
                position: absolute;
                z-index: 1;
                width: 15px;
                height: 15px;
                background-color: black;
                margin: 34px;
              "
            >
              <div style="position: absolute; margin-top: -5px">
                <q-icon
                  color="white"
                  size="10px"
                  name="check"
                  style="font-weight: bold"
                />
              </div>
            </div>
            <div
              id="colour_circle"
              :style="`background-color:${sku.options.colour.hex}`"
              style="
                border: 2px #f6f6f6 solid;
                border-radius: 50px;
                position: absolute;
                width: 40px;
                height: 40px;
                margin: 5px;
              "
            ></div>
            <!-- <div id="colour_qty" class="text-center " style="color: black; text-shadow: -0.7px -0.7px 0 #fff, 0.7px -0.7px 0 #fff, -0.7px 0.7px 0 #fff, 0.7px 0.7px 0 #fff; font-size:11px; background-color:;position:absolute; width:50px;z-index:1; margin:18px 0">{{index}}</div> -->
            <div
              v-if="productDetails.basic_details.options.show_qty_colour"
              id="colour_qty"
              class="text-center text-bold"
              style="
                font-size: 11px;
                background-color: ;
                position: absolute;
                width: 50px;
                z-index: 1;
                margin: 18px 0;
              "
            >
              {{ colourQty[index] }}
            </div>
          </div>
          <!-- <div id=colour_name class="text-center" style="font-size:10px;">{{sku.options.colour.name}}</div> -->
        </div>
      </div>

      <div id="buttons" class="row justify-center" style="margin: 15px 0">
        <q-input
          :min="0"
          :max="10"
          v-model="colourQty[colourSelection]"
          @input="onInput($event, colourSelection)"
          @keydown="keyHandler($event, colourSelection)"
          debounce="1000"
          maxlength="5"
          dense
          outlined
          input-style="font-weight:bold; text-align:center; width:60px;"
          style="margin: 0 10px"
        >
          <template v-slot:prepend>
            <q-btn
              color="black"
              @click="removeOne(colourSelection)"
              dense
              flat
              icon="remove"
              style="margin: -8px"
            />
          </template>
          <template v-slot:append>
            <q-btn
              color="black"
              @click="addOne(colourSelection)"
              dense
              flat
              icon="add"
              style="margin: -8px"
            />
          </template>
        </q-input>
        <q-btn color="primary" label="Add to cart" />
        <q-btn
          v-if="productDetails.basic_details.options.show_whishing_btn"
          style="margin: 0 10px"
          icon="favorite_border"
        />
      </div>
      <div style="text-align:center"><i>Only {{product.skus[0].stock}} left in stock</i></div>
    </div>
    <div class="col-12" v-if="productDetails">
      <!-- Content -->
      <div
        v-if="productDetails.feature_panel.show"
        class="col-12"
        style="margin: 50px 0px"
      >
        <div class="row">

          <div class="col-xs-12 col-md-6">
            <h1 style="font-weight:800;margin:0;font-size:3.8em;letter-spacing:-0.02em;color:#000000;line-height:1.05;">The perfect balance between mobility, durability, and affordability.</h1>
          </div>

          <div class="col-12">
            <q-img
              src="https://climbicp.shop/wp-content/uploads/2022/03/ICP-Home--scaled.jpg"
              :ratio="16/9"
              spinner-color="primary"
              spinner-size="82px"
              cover
              height="100%"
            />
          </div>
          <!-- BOX -->
          <div class="col-xs-12 col-md-6" style="padding: 50px 10px; position: relative; text-align: center; color: white;">
            <q-img
              src="https://climbicp.shop/wp-content/uploads/2020/01/ICP-Home-4-scaled.jpg"
              :ratio="1"
              spinner-color="primary"
              spinner-size="82px"
              fit
              position="50% 50%"
            />
            <div style="position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%); z-index:100">
              <h3 style="font-size:32px; font-weight:bold">100% Freestanding</h3>
              <p style="font-size:18px;line-height 1.8em;font-weight:bold">Zero damage to floors and walls
Perfect for renters</p>
            </div>
          </div>
          <!-- BOX -->
          <div class="col-xs-12 col-md-6" style="padding: 50px 10px; position: relative; text-align: center; color: white;">
            <q-img
              src="https://climbicp.shop/wp-content/uploads/2020/01/ICP-Home-3-3-scaled.jpg"
              :ratio="1"
              spinner-color="primary"
              spinner-size="82px"
              fit
              position="50% 50%"
            />
            <div style="position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%); z-index:100">
              <h3 style="font-size:32px; font-weight:bold">Simple Cantilevered Frame</h3>
              <p style="font-size:18px;line-height 1.8em;font-weight:bold">No mechanisms in the way of climbing.
Easy to assemble.</p>
            </div>
          </div>
          <!-- Text Banner -->
          <div class="col-12" style="text-align: center; font-size:58px; font-weight:bold; margin-bottom:50px">
            <p>Designed to be</p>            
          </div>

          <div class="col-xs-12 col-md-4" style="padding: 10px 50px">
            <p style="font-size:22px;font-weight:bold">Convenient</p>
            <p style="font-size:17px">
              Easy to assemble and completely collapsible. All tools are included.*
            </p>
            <p style="font-size:17px">
              A full size training wall you can take with you wherever you live and fit in most homes.
            </p>          
          </div>  

          <div class="col-xs-12 col-md-4" style="padding: 10px 50px">
            <p style="font-size:22px;font-weight:bold">The Strongest</p>
            <p style="font-size:17px">
              The stunning steel frame is laser cut and the plywood panels from the world’s highest quality Birch.
            </p>
            <p style="font-size:17px">
              The strong design, can be rebuilt many times over.
            </p>          
          </div>

          <div class="col-xs-12 col-md-4" style="padding: 10px 50px">
            <p style="font-size:22px;font-weight:bold">Compatible</p>
            <p style="font-size:17px">
              A design that works with Kilter Board, Tension & Moonboard climbing wall sets.
            </p>
            <p style="font-size:17px">
              Or, you get to create a wall that fits your climbing style and looks just the way you want.
            </p>          
          </div>  

          <!-- BOX WITH TEXT FULL SIZE -->
          <div class="col-12 column items-end" style=" text-align:left; color: white; backgound-color: rgba(255, 255, 255, 0); background-image: linear-gradient(48deg, rgba(127, 191, 0, 0.46) 24%,rgba(0, 0, 0, 0.5) 49%),url('https://climbicp.shop/wp-content/uploads/2022/03/ICP-Home-3-2-scaled.jpg'); background-position: center bottom; background-repeat: no-repeat; border-width: 0px; border-color: rgb(226, 226, 226); border-style: solid; background-size: cover; visibility: visible; animation-duration: 1.3s; ">
            <div class="col-3" style="padding:100px">
              <p style="text-align:right;font-size:48px;font-weight:bold">One board to rule them all</p>
              <p style="text-align:right;font-size:22px;line-height 1.8em;font-weight:bold">Works with Kilter Board, Tension & Moonboard sets</p>
              <p style="text-align:right;font-size:18px;line-height 1.8em;font-weight:bold">Kilterboard Home Wall 7×10′</p>
              <p style="text-align:right;font-size:18px;line-height 1.8em;font-weight:bold">Tension Board 8×10’</p>
              <p style="text-align:right;font-size:18px;line-height 1.8em;font-weight:bold">Mini Moonboard</p>
              <p style="text-align:right;font-size:18px;line-height 1.8em;font-weight:bold">Or your personal spray wall</p>
            </div>
          </div>


          <!-- BOX -->
          <div class="col-xs-12 col-md-6" style="padding: 50px 10px; position: relative; text-align: center; color: white;">
            <q-img
              src="https://climbicp.shop/wp-content/uploads/2020/01/ICP-Home-2-2-2-1200x800-1.jpg"
              :ratio="1"
              spinner-color="primary"
              spinner-size="82px"
              fit
              position="50% 50%"
            />
            <div style="position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%); z-index:100">
              <h3 style="font-size:32px; font-weight:bold">Hang Out On The Edge</h3>
              <p style="font-size:18px;line-height 1.8em;font-weight:bold">Detailed CNC rounded steel edges feel comfortable to hang on</p>
            </div>
          </div>
          <!-- BOX -->
          <div class="col-xs-12 col-md-6" style="padding: 50px 10px; position: relative; text-align: center; color: white;">
            <q-img
              src="https://climbicp.shop/wp-content/uploads/2020/01/ICP-Home-8-1200x798-1.jpg"
              :ratio="1"
              spinner-color="primary"
              spinner-size="82px"
              fit
              position="50% 50%"
            />
            <div style="position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%); z-index:100">
              <h3 style="font-size:32px; font-weight:bold">Nothing In The Way</h3>
              <p style="font-size:18px;line-height 1.8em;font-weight:bold">No mechanisms or obstructions to get in the way of flagging or falling</p>
            </div>
          </div>

          <!-- TEXT +  Video -->
          <div class="col-md-4">
            <p style="font-size:35px">Set and Forget Angles</p>
            <p style="font-size:18px">Durability, ease of assembly and performance is at the heart of ICP Home. Our simple design does away with pulleys, gears and winches that adjust your wall easily from 20° – 50° during assembly.</p>
          </div>
          <div class="col-md-8">
            <video width="100%" height="100%" autoplay loop controls>
              <source src="https://climbicp.shop/wp-content/uploads/2020/01/SetForget.mp4" type="video/mp4">
            </video>
          </div>

          <div class="col-md-4" style="margin: 20px 0">
            <q-img
              src="https://climbicp.shop/wp-content/uploads/2020/01/ICP-Home_orange.jpg"
              :ratio="16/9"
              spinner-color="primary"
              spinner-size="82px"
              fit
            />
          </div>         
          <div class="col-md-4" style="margin: 20px 0">
            <q-img
              src="https://climbicp.shop/wp-content/uploads/2020/01/ICP-Home_red.jpg"
              :ratio="16/9"
              spinner-color="primary"
              spinner-size="82px"
              fit
            />
          </div>   
          <div class="col-md-4" style="margin: 20px 0">
            <q-img
              src="https://climbicp.shop/wp-content/uploads/2020/01/ICP-Home_green-400x266.jpg"
              :ratio="16/9"
              spinner-color="primary"
              spinner-size="82px"
              fit
            />
          </div> 


          <div class="col-12">
            <h3>Product Information & Specifications</h3>
            <p style="font-size: 16px"><b>Total weight:</b> Approximately 400kg. The heaviest individual parts are 34kg.</p>
            <p style="font-size: 16px"><b>Shipping size:</b> Comes on standard double pallet – 2400 x 1200mm. The largest individual parts are the timber panels at 1.2 x 2.4m.</p>
            <p style="font-size: 16px"><b>Materials:</b> 100% steel frame with 18mm Birch wooden panels. 2 socket wrenches and 2 Allen keys also included.</p>            
            <p style="font-size: 16px"><b>Climbing holds with bolts & LED:</b> Not included</p>
            <p style="font-size: 16px"><b>Safety Matting:</b> Not included</p>            
          </div>



          <div class="col-xs-12 col-md-6">
            <q-img
              src="https://climbicp.shop/wp-content/uploads/2020/01/ICP-Home_WidthHeightsDiagram-1-1024x1024-1-800x800.jpeg"
              
              spinner-color="primary"
              spinner-size="82px"
              
            />            
          </div>
          <div class="col-xs-12 col-md-6">
            <q-img
              src="https://climbicp.shop/wp-content/uploads/2022/04/ICP-Home_AnglesHeightsDiagram-V2-600x600.jpg"
              
              spinner-color="primary"
              spinner-size="82px"
              fit
            />            
          </div>

          <!-- BOX WITH TEXT FULL SIZE -->
          <div class="col-12 column items-end" 
          style="
            text-align:left; 
            color: white; 
            background-color: rgba(255, 255, 255, 0);
             background-image: linear-gradient(48deg, rgba(127, 191, 0, 0.46) 24%,rgba(0, 0, 0, 0.5) 49%),url('https://climbicp.shop/wp-content/uploads/2022/04/DeepForest_1-scaled.jpeg'); 
             background-position: center bottom; background-repeat: no-repeat; border-width: 0px; border-color: rgb(226, 226, 226); border-style: solid; background-size: cover; visibility: visible; animation-duration: 1.3s; ">
            <div class="col-3" style="padding:30px">
              <p style="font-size:32px;font-weight:bold">Carbon Positive</p>
              <p style="font-size:18px;line-height 1.8em;">We do not use materials from any country that does not respect human rights.</p>
              <p style="font-size:18px;line-height 1.8em;">Not only are we carbon positive but we are also working to remove all unethically sourced materials from our supply chain.</p>
            </div>
          </div>


<!-- Closing TAGS -->
        </div>
      </div>
    </div>
  </div>
  <!-- </div> -->
</template>


<script>
import moment from "moment";
import gql from "graphql-tag";

export default {
  apollo: {
    cart() {
      return {
        query: gql`
          query cart($id: ID!) {
            cart(id: $id) {
              id
              items {
                id
                skuId
                qty
                sku {
                  id
                  options
                  product {
                    id
                    name
                    attributes
                  }
                }
              }
            }
          }
        `,
        variables() {
          return {
            id: this.$store.state.auth.retailCartId,
          };
        },
        context: {
          headers: {
            uuid: this.UUID,
          },
        },
        fetchPolicy: "network-only",
      };
    },
    product() {
      return {
        query: gql`
          query product($id: ID!) {
            product(id: $id) {
              id
              name
              description
              reference
              images {
                url
                name
              }
              attributes
              urlSlug
              skus {
                id
                attributes
                barcode
                options
                price
                containerPrice
                retailPrice
                showInContainer
                showInRetail
                hideInStock
                stock
                colour
                deleted
              }
            }
          }
        `,
        variables() {
          return {
            id: this.$route.params.id,
          };
        },
        context: {
          headers: {
            uuid: this.UUID,
          },
        },     
        fetchPolicy: "network-only",
      };
    },
    productDetails() {
      return {
        query: gql`
          query productDetails($id: ID!) {
            productDetails(id: $id) {
              id
              productId
              basic_details {
                subtitle
                show_subtitle
                options
              }
              feature_panel {
                show
                content
              }
              technical_details_panel {
                show
                content
              }
              review_panel {
                show
                show_rating_breakdown
                show_product_recomendation_subpanel
                show_write_btn
                show_helpful_line
              }
            }
          }
        `,
        variables() {
          return {
            id: this.$route.params.id,
          };
        },
        context: {
          headers: {
            uuid: this.UUID,
          },
        },        
        fetchPolicy: "network-only",
      };
    },
  },
  data() {
    return {
      name: "abc",
      slideValue: "2",
      objMarkerLabel: { 0: "Poor", 10: "Great" },
      date: new moment().format("LLL"),
      reviewSort: "Most Recent",
      options: [
        "Most Recent",
        "Most Relevant",
        "Most Helpful",
        "High to Low (Rating)",
        "Low to High (Rating)",
      ],
      colourSelection: 0,
      colourOptions: ["red", "blue", "yellow"],
      slide: 0,
      autoplay: false,
      fullscreen: false,
      selected: "border:4px solid black",
      colourQty: [],
      execCounter: 0,
      images:'',
      viewerPerc: 0
    };
  },
  mounted (){
    this.scrollWatcher();
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    cartId() {
      return this.$store.state.cart.activeRetailCart.id;
    },
    UUID(){     
      return this.$store.state.auth.currentUUID;
    },
    async setQtyComp() {
      if(this.cart){
        for (let i = 0; i < this.product.skus.length; i++) {
          let flag = false;
          for (let item of this.cart.items) {
            if (item.skuId == this.product.skus[i].id) {
              this.colourQty[i] = item.qty;
              flag = true;
              continue;
            }
          }

          if (!flag) {
            this.colourQty[i] = 0;
          }
        }
      }
    },
  },
  methods: {
    scrollWatcher(){
      window.onscroll = () => {
        let viewed = (((Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight) / document.documentElement.offsetHeight) * 100).toFixed(0)        
        if(viewed % 10 == 0 && viewed > this.viewerPerc ){
          this.viewerPerc = Math.max(this.viewerPerc,viewed)
            analytics.track("Product Details % Viewed",{
              storeType: this.$store.state.cart.currentStoreType,
              product: this.product.name,
              where: "Product Details Page"    
            });    
        }       
      }
    },
    async updateBasket(skuId, value) {      
      value = Number(value);
      try {
        if ( value > 0 && !this.cart.items.find((item) => item.skuId === skuId) ) {
          await this.$apollo.mutate({
            mutation: gql`
              mutation addItemToCart($cartId: ID!, $input: CartItemInput!) {
                addItemToCart(id: $cartId, input: $input) {
                  id
                  items {
                    id
                    skuId
                    sku {
                      id
                      price
                      containerPrice
                      retailPrice
                      options
                      stock
                      product {
                        id
                      }
                    }
                    qty
                  }
                }
              }
            `,
            variables: {
              cartId: this.cartId,
              input: {
                skuId: skuId,
                qty: value,
              },
            },
            context: {
              headers: {
                uuid: this.UUID,
              },
            },
            skip() {
              return !value;
            },
          });
          
          const skuToSendToAnalytics = await this.cart.items.find( (item) => item.skuId === skuId ).sku;          
          analytics.track("Add Item To Cart", {
            cartId: this.cartId,
            skuId: skuId,
            sku: skuToSendToAnalytics,
            qty: value,
            where: "Product Details Page",
            storeType: this.$store.state.cart.currentStoreType
          });          
        } else if (
          value === 0 &&
          this.cart.items.find((item) => item.skuId === skuId)
        ) {
          await this.$apollo.mutate({
            mutation: gql`
              mutation deleteItemFromCart($cartId: ID!, $skuId: ID!) {
                deleteItemFromCart(id: $cartId, skuId: $skuId) {
                  id
                  items {
                    id
                    skuId
                    qty
                  }
                }
              }
            `,
            variables: {
              cartId: this.cartId,
              skuId: skuId,
            },
            context: {
              headers: {
                uuid: this.UUID,
              },
            },
          });         
          analytics.track("Delete Item From Cart", {
            cartId: this.cartId,
            skuId: skuId,
            where: "Product Details Page",
            storeType: this.$store.state.cart.currentStoreType
          });       


        } else if (this.cart.items.find((item) => item.skuId === skuId)) {
          await this.$apollo.mutate({
            mutation: gql`
              mutation editItemInCart(
                $cartId: ID!
                $skuId: ID!
                $input: CartItemInput!
              ) {
                editItemInCart(id: $cartId, skuId: $skuId, input: $input) {
                  id
                  items {
                    id
                    skuId
                    qty
                  }
                }
              }
            `,
            variables: {
              cartId: this.cartId,
              skuId: skuId,
              input: {
                qty: value,
              },
            },
            context: {
              headers: {
                uuid: this.UUID,
              },
            },            
          });
          
          analytics.track("Edit Item In Cart", {
            cartId: this.cart.id,
            skuId: skuId,
            updates: {
              qty: value,
            },
            where: "Product Details Page",
            storeType: this.$store.state.cart.currentStoreType
          });           
        }
      } catch (err) {
        // this.$q.notify({
        //   message: 'Error updating!',
        //   color: 'negative',
        //   icon: 'report_problem'
        // })
      }
      this.$store.commit(
        `cart/setCartRetailQty`,
        this.cart.items?.reduce((p, c, i) => p + Number(c.qty), 0)
      );
    },
    getData() {
      console.log("this.$store", this.$store.state.cart);
      return JSON.stringify(this.$store.state.cart.activeContainerCart);
    },
    async addOne(index) {
      let newVal = this.colourQty[index] + 1;
      this.$set(this.colourQty, index, newVal);
      let skuid = this.product.skus[index].id;
      // await this.editItemInCart_mutation(this.cartId, skuid, newVal)
      await this.updateBasket(skuid, newVal);
    },
    async removeOne(index) {
      let val = this.colourQty[index];
      let newVal;
      if (val > 0) newVal = val - 1;
      else newVal = 0;

      let skuid = this.product.skus[index].id;
      // await this.editItemInCart_mutation(this.cartId, skuid, newVal)
      await this.updateBasket(skuid, newVal);
    },
    async manual_qty_update(index, qty) {
      this.$set(this.colourQty, index, qty);
    },
    async onInput(val, index) {
      // console.log('val,index',val,index);
      let newVal = val;
      this.colourQty[index] = val;
      if (val && val < 0) {
        this.colourQty[index] = 0;
        newVal = 0;
      }
      let skuid = this.product.skus[index].id;
      await this.updateBasket(skuid, newVal);
    },
    keyHandler(evt, index) {
      if (this.colourQty[index] < 1 && evt.key === "ArrowDown") {
        evt.preventDefault();
      }
      if (evt.key === "-") {
        evt.preventDefault();
      }
    },
    //Input: Cart ID, SKU ID and Quantity
    async addItemToCart_mutation(cartId, skuId, qty) {
      try {
        const result = await this.$apollo.mutate({
          mutation: gql`
            mutation addItemToCart($cartId: ID!, $input: CartItemInput!) {
              addItemToCart(id: $cartId, input: $input) {
                id
                items {
                  id
                  skuId
                  sku {
                    id
                    price
                    containerPrice
                    retailPrice
                    options
                    stock
                    product {
                      id
                    }
                  }
                  qty
                }
              }
            }
          `,
          variables: {
            cartId: cartId,
            input: {
              skuId: skuId,
              qty: Number(qty),
            },
          },
          context: {
            headers: {
              uuid: this.UUID,
            },

          },
          skip() {
            return !qty;
          },
        });
        console.log("addItemToCart", result);
      } catch (err) {
        console.log("ERROR addItemToCart", err);
      }
      this.$store.commit(
        `cart/setCartRetailQty`,
        this.cart.items?.reduce((p, c, i) => p + Number(c.qty), 0)
      );
    },
    async editItemInCart_mutation(cartId, skuId, qty) {
      try {
        await this.$apollo.mutate({
          mutation: gql`
            mutation editItemInCart(
              $cartId: ID!
              $skuId: ID!
              $input: CartItemInput!
            ) {
              editItemInCart(id: $cartId, skuId: $skuId, input: $input) {
                id
                items {
                  id
                  skuId
                  qty
                }
              }
            }
          `,
          variables: {
            cartId: cartId,
            skuId: skuId,
            input: {
              qty: qty,
            },
          },
            context: {
              headers: {
                uuid: this.UUID,
              },
            },          
        });
      } catch (err) {
        console.log("ERROR editItemInCart_mutation", err);
      }
      this.$store.commit(
        `cart/setCartRetailQty`,
        this.cart.items?.reduce((p, c, i) => p + Number(c.qty), 0)
      );
    },
  },
};
</script>




<style scoped lang="stylus">
@import '~quasar-variables';

.customBadge {
  padding: 3px 6px;
  font-size: 14px;
  border: 2px solid #C5171C;
  color: #C5171C;
  background-color: white;
}
</style>


